import { type FieldValues } from '@restore/dynamic-forms';

export const stripCheckboxFalseValues = (fieldValues: FieldValues) => {
  const cleanedFields = fieldValues;

  for (const [key, value] of Object.entries(fieldValues)) {
    if (Array.isArray(value)) {
      cleanedFields[key] = value.filter((checkVal) => {
        return checkVal !== false;
      });
    }
  }

  return cleanedFields;
};
